import {useCallback, useEffect, useState} from 'react';

import {useDispatch} from 'react-redux';
import {hostApi, useConnectPaymentIntegrationMutation} from 'services/schedulerInternal';

import {connectAccount, connectMeetIntegration} from 'Store/IntegrationStore';
import {LOCAL_STORAGE_KEYS, PAYMENT_INTEGRATION_TYPE, PROVIDER_TYPE} from 'Utils/consts';

const useListenConnectAccountEvent = (onSuccess) => {
  const dispatch = useDispatch();
  const [connectPaymentIntegration] = useConnectPaymentIntegrationMutation();
  const [isConnecting, setIsConnecting] = useState(false);
  const onConnectStatusChange = useCallback(
    async (event) => {
      if (event.key === LOCAL_STORAGE_KEYS.CONNECT_STATUS) {
        const connectInfo = JSON.parse(event.newValue);
        try {
          setIsConnecting(true);
          if (connectInfo.service === PAYMENT_INTEGRATION_TYPE.STRIPE) {
            if (!connectInfo.code && !connectInfo.state) {
              // if code and state not provided in redirect url, it means the user has not finished payment onboarding,
              // we need to refetch the payment integration data and let user to continue onboarding
              dispatch(hostApi.endpoints.getPaymentIntegration.initiate(connectInfo.service, {forceRefetch: true}));
            } else {
              await connectPaymentIntegration(connectInfo).unwrap();
            }
          } else if ([PROVIDER_TYPE.GOOGLE_MEET, PROVIDER_TYPE.TEAMS_MEETING].includes(connectInfo.service)) {
            await dispatch(connectMeetIntegration(connectInfo)).unwrap();
          } else {
            await dispatch(connectAccount(connectInfo)).unwrap();
          }
          onSuccess?.(connectInfo);
        } catch (error) {
          console.error('connect account failed', error);
        } finally {
          setIsConnecting(false);
        }
      }
    },
    [dispatch, connectPaymentIntegration, onSuccess]
  );
  useEffect(() => {
    window.addEventListener('storage', onConnectStatusChange);
    return () => {
      window.removeEventListener('storage', onConnectStatusChange);
    };
  }, [onConnectStatusChange]);
  return {
    isConnecting,
  };
};
export default useListenConnectAccountEvent;
